export const LIST_GROUPING_STORAGE_KEY = "unibox_list_grouping";

export function readListGrouping() {
  try {
    const stored = localStorage.getItem(LIST_GROUPING_STORAGE_KEY);
    if (stored === "conversation" || stored === "account") return stored;
    return "account";
  } catch {
    return "account";
  }
}

export function normalizeEmail(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";

  const bracketMatch = raw.match(/<([^>]+)>/);
  if (bracketMatch?.[1]) return bracketMatch[1].trim();

  const firstItem = raw.split(",")[0]?.trim() || "";
  const emailMatch = firstItem.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i);
  return (emailMatch?.[0] || firstItem).toLowerCase();
}

export function parseAllEmails(...fields) {
  const set = new Set();
  for (const field of fields) {
    const raw = String(field || "");
    for (const m of raw.matchAll(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi)) {
      set.add(m[0].toLowerCase());
    }
  }
  return [...set];
}

export function getEmailContact(email) {
  const account = normalizeEmail(email?.accountEmail);
  const from = normalizeEmail(email?.from);
  const fromSentFolder = String(email?.gmailId || "").includes(":sent:");

  const direction =
    email?.direction ||
    (fromSentFolder || (from && from === account) ? "sent" : "received");

  if (direction === "received") {
    if (
      from &&
      account &&
      from === account &&
      parseAllEmails(email?.to_email, email?.cc_email).length <= 1
    ) {
      return "yo-mismo";
    }
    if (from) return from;
    return "desconocido";
  }

  const recipients = parseAllEmails(email?.to_email, email?.cc_email);
  if (!recipients.length) return from === account ? "yo-mismo" : "enviado";

  const first =
    recipients.find((r) => r !== account) ||
    recipients.find((r) => r === account) ||
    recipients[0];
  if (first === account) return "yo-mismo";
  return first;
}

/** Cuenta desde la que debe salir la respuesta (la que recibió el mensaje). */
export function getReplyFromEmail(email, accounts = []) {
  const fromAccount = normalizeEmail(email?.accountEmail);
  if (fromAccount) return fromAccount;

  const byId = (accounts || []).find(
    (a) => Number(a.id) === Number(email?.accountId)
  );
  if (byId?.email) return normalizeEmail(byId.email);

  return normalizeEmail(accounts[0]?.email);
}

export function parseThreadKey(threadKey) {
  const str = String(threadKey || "");
  const parts = str.split("::");

  if (parts.length >= 3) {
    if (parts[1] === "c") {
      return {
        mode: "account",
        account: parts[0],
        contact: parts.slice(2).join("::"),
        threadId: null,
      };
    }
    if (parts[1] === "t") {
      return {
        mode: "conversation",
        account: parts[0],
        contact: null,
        threadId: parts.slice(2).join("::"),
      };
    }
  }

  const idx = str.indexOf("::");
  if (idx === -1) {
    return { mode: "account", account: null, contact: str, threadId: null };
  }

  return {
    mode: "account",
    account: str.slice(0, idx),
    contact: str.slice(idx + 2),
    threadId: null,
  };
}

export function buildGroupedThreads(rawThreads, listGrouping = "account") {
  const result = {};

  Object.values(rawThreads || {}).forEach((emails) => {
    (emails || []).forEach((email) => {
      const account = normalizeEmail(email.accountEmail);
      if (!account) return;

      const contact = getEmailContact(email);
      if (!contact) return;

      let key;
      if (listGrouping === "conversation") {
        const threadId = String(email.threadId || email.gmailId || "").trim();
        if (!threadId) return;
        key = `${account}::t::${threadId}`;
      } else {
        key = `${account}::c::${contact}`;
      }

      if (!result[key]) result[key] = [];
      result[key].push(email);
    });
  });

  return result;
}
